export default function Footer() {
  return (
    <footer id="footer" className="pt-14 md:pt-20 px-4 md:px-6 bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 pb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-950">久播影院</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              久播影院是专注高清影视的免费在线观影平台，汇聚全球优质电影、高分剧集、经典老片与热门综艺，致力于为华语观众提供高清流畅的免费观影体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a>
              <a href="#carousel" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">精选专题</a>
              <a href="#index" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">分类索引</a>
              <a href="#updates" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">最新快讯</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">帮助中心</h4>
            <div className="flex flex-col gap-2">
              <a href="#faq" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
              <a href="#features" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">平台优势</a>
              <a href="#about" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
              <a href="#contact" className="text-sm text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">联系投稿</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">合作伙伴</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-500">更多合作伙伴即将上线</span>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2020 - 2026 久播影院 · 高清免费在线观看平台 · 版权所有
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">不缓冲 · 不卡顿 · 不收费</span>
          </div>
        </div>
      </div>
    </footer>
  );
}